const IGNORED_ERRORS = /InvalidAccessError|SecurityError/;

// Use to decorate a function to prevent errors.
export const tryFunctionHelperModule = angular
  .module('Q.helpers.try-function', [])

  .factory('tryFunction', function ($log) {
    return function tryFunction(fn) {
      return function (...args) {
        try {
          return fn(...args);
        } catch (ex) {
          if (IGNORED_ERRORS.test(ex)) {
            $log.debug(ex);
          } else {
            $log.error(ex);
          }
        }
      };
    };
  });
